/* jquery ready */
/* ************ */

(function($, duo, undefined) {

  "use strict";

  $(function() {
    if($('.request-banner').length > 0) {

      // setup datepickers:
      // setting up datepickers inside the Drupal behavior
      // causes a JS-error in Safari (tested in Safari 14)

      let datepickerLocale = 'en';
      const pageLanguage = drupalSettings.path.currentLanguage;
      if(pageLanguage === 'nl' || pageLanguage === 'fr') {
        datepickerLocale = pageLanguage;
      }

      $("#ask-quote-now-form #edit-departure").flatpickr({
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: datepickerLocale
      });

      // after the datepickers have been set up,
      // set up the form labels:
      setupFormLabels();

      // setup scroll-link:
      setupScrollLink();

      // add "js-processed" class:
      $('.request-banner').addClass('js-processed');
    }
  });

  function setupFormLabels() {

    // go through all form controls and remove placeholder text,
    // and try to disable autocomplete:
    $('.request-banner input').each(function(index, element) {
      $(element).attr('placeholder', '');
      $(element).attr('autocomplete', 'off');
    });

    // add custom labels:
    // -> departure address:
    const $formblockDeparture = $('.request-banner .form-item-departure-address');
    if($formblockDeparture.length > 0) {
      const $visibleInputDeparture = $formblockDeparture.find('.address-autocomplete .js--address-autocomplete');
      // --> add an ID to the visible text input:
      $visibleInputDeparture.attr('id', 'input-departure-element');
      // --> wrap the input in a container:
      $visibleInputDeparture.wrap('<div class="custom-label-holder"></div>');
      // --> create a label:
      const $departureLabel = $(`<label class="custom-label custom-label--departure" for="input-departure-element">
        <div class="custom-label__inner">
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M18.8 7.5l4.5 4.5-4.5 4.5-.9-.9 2.8-2.8H8.2v-1.5h12.4l-2.8-2.8 1-1zM3.8 9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm0 1.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z" />
          </svg>
          <span>${ Drupal.t('Departure') }</span>
        </div>
      </label>`);
      $departureLabel.insertBefore($visibleInputDeparture);
    }
    // -> destionation address:
    const $formblockDestination = $('.request-banner .form-item-departure-address-destination');
    if($formblockDestination.length > 0) {
      const $visibleInputDestination = $formblockDestination.find('.address-autocomplete .js--address-autocomplete');
      // --> add an ID to the visible text input:
      $visibleInputDestination.attr('id', 'input-destination-element');
      // --> wrap the input in a container:
      $visibleInputDestination.wrap('<div class="custom-label-holder"></div>');
      // --> create a label:
      const $departureLabel = $(`<label class="custom-label custom-label--destination" for="input-destination-element">
        <div class="custom-label__inner">
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M11.3 7.5l4.5 4.5-4.5 4.5-.9-.9 2.8-2.8H.8v-1.5h12.4l-2.8-2.8.9-1zM20.2 9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.4-3 3-3zm0 1.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.6-1.5-1.5-1.5z" />
          </svg>
          <span>${ Drupal.t('Destination') }</span>
        </div>
      </label>`);
      $departureLabel.insertBefore($visibleInputDestination);
    }
    // -> date:
    const $formblockDate = $('.request-banner .form-item-departure');
    if($formblockDate.length > 0) {
      // --> get the correct date-control (input type "text" when the custom
      //     datepicker is active, and type "date" with the default html date):
      let $visibleInputDate = $formblockDate.find('input[type="text"].form-date');
      if($visibleInputDate.length === 0) {
        $visibleInputDate = $formblockDate.find('input[type="date"].form-date');
      }
      // --> add an ID to the visible text input:
      $visibleInputDate.attr('id', 'input-date-element');
      // --> wrap the input in a container:
      $visibleInputDate.wrap('<div class="custom-label-holder"></div>');
      // --> create a label:
      const $departureLabel = $(`<label class="custom-label custom-label--date" for="input-date-element">
        <div class="custom-label__inner">
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M15.7 3.8c.4 0 .8.3.8.8v.7h.8c1.7 0 3 1.3 3 3v9c0 1.7-1.3 3-3 3H6.8c-1.7 0-3-1.3-3-3v-9c0-1.7 1.3-3 3-3h.7v-.7c0-.4.3-.8.8-.8.4 0 .7.3.7.7v.7h5.9v-.7c0-.4.4-.7.8-.7zm3.1 8.2H5.2v5.2c0 .8.6 1.4 1.4 1.5h10.6c.8 0 1.4-.6 1.5-1.4V12zM7.4 6.8h-.6c-.8 0-1.5.6-1.5 1.3V10.4h13.5V8.2c0-.8-.6-1.4-1.4-1.5h-.9v.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-.7H9v.7c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8v-.6z" />
          </svg>
          <span>${ Drupal.t('Date') }</span>
        </div>
      </label>`);
      $departureLabel.insertBefore($visibleInputDate);
    }

    // focus events:

    $(document).on('focus', `.custom-label-holder input`, function(e) {
      $(this).addClass('js-has-focus');
      $(this).parents('.custom-label-holder').addClass('js-child-has-focus');
    });
  
    $(document).on('blur', `.custom-label-holder input`, function(e) {
      var textbox = $(this);
      if (textbox.val() === '') {
        $(this).removeClass('js-has-focus');
        $(this).parents('.custom-label-holder').removeClass('js-child-has-focus');
      }
    });
  }

  function setupScrollLink() {

    new duo.SmoothScroll({
      selector: '.js-request-banner-scroll-link',
      moveFocus: false
    });
  }

})(jQuery, window.duo = window.duo || {});
